import { Component, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import { ReservationSummaryOwnerDialogComponent } from './reservation-summary-owner-dialog/reservation-summary-owner-dialog.component';

import { ReservationService } from '../../reservation.service';
import { RouterService } from '@/common/route.service';
import { Organization, Reservation, UserData } from '../../reservation.model';
import { TypeValueFactoryService } from '@/common/type-value-factory.service';
import { OwnerSearchComponent } from '@/reservation/reservation-summary/reservation-summary-owner/reservation-summary-owner-dialog/owner-search/owner-search.component';

@Component({
	selector: 'app-reservation-summary-owner',
	templateUrl: './reservation-summary-owner.component.html',
	styleUrls: ['./reservation-summary-owner.component.scss'],
})
export class ReservationSummaryOwnerComponent implements OnDestroy {
	ownerUser: UserData = null;
	ownerOrganization: Organization = null;
	reservation: Reservation = TypeValueFactoryService.createReservationObject();
	reservationSubscription: Subscription;
	matPersonalInformationData = new MatTableDataSource<any>();
	isOrganization = false;

	displayedPersonalInfoColumns = [];

	constructor(
		public dialog: MatDialog,
		public _service: ReservationService,
		private readonly router: RouterService,
	) {
		this.reservationSubscription = _service.reservation$.subscribe((value) => {
			this.reservation = value;
			this.ownerUser = value.ownerUser;
			this.ownerOrganization = value.ownerOrganization;

			this.isOrganization = this.ownerOrganization !== null;
			this.matPersonalInformationData.data = this.isOrganization
				? [
						{
							...value.ownerOrganization,
							email: this.getOrganizationEmail(this.ownerOrganization),
							phone_number: this.getOrganizationPhone(this.ownerOrganization),
						},
					]
				: [
						{
							...this.ownerUser,
							email: this.ownerUser.userContacts[0]?.email,
							phone_number: this.ownerUser.userContacts[0]?.phone,
						},
					];

			this.updatePersonalInfoColumns();
		});
	}

	changeOwner(ownerData: UserData | Organization | null = null, isSearch = false): void {
		if (isSearch) {
			this.dialog?.open(OwnerSearchComponent, {
				disableClose: true,
				width: '1200px',
			});
			return;
		}

		if (this.ownerOrganization) {
			this.router.navigate([`/organization/${this.ownerOrganization.id}`]);
		} else {
			this.dialog?.open(ReservationSummaryOwnerDialogComponent, {
				disableClose: true,
				width: '1200px',
				data: {
					reservation: this.reservation,
					ownerData,
				},
			});
		}
	}
	ngOnDestroy(): void {
		this.reservationSubscription?.unsubscribe();
	}

	get city() {
		if (this.ownerUser && this.ownerUser.city && this.ownerUser.userAddresses.length)
			return `${this.ownerUser.city} ${this.ownerUser.userAddresses[0]?.zipCode}`;
		return 'Brak';
	}

	private getOrganizationPhone(organization: Organization) {
		return organization.departments.length ? organization.departments[0].departmentContacts[0].phone : 'Brak';
	}

	private getOrganizationEmail(organization: Organization) {
		return organization.departments.length ? organization.departments[0].departmentContacts[0].email : 'Brak';
	}

	private updatePersonalInfoColumns() {
		this.displayedPersonalInfoColumns = this.isOrganization
			? ['name', 'nip', 'phone_number', 'email']
			: ['sex', 'firstName', 'lastName', 'phone_number', 'email'];
	}

	protected showOwnerReservations() {
		const urlParams = `owner_name=${this.reservation.ownerUser.firstName} ${this.reservation.ownerUser.lastName}`;
		window.open(`/reservationList?${urlParams}`, '_blank');
	}
}
